import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import Aboutcard from "./AboutCard";
import laptopImg from "../../Assets/about.png";

function About() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 480);

  // Check for mobile and small screen on resize
  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setIsMobile(width <= 768);
      setIsSmallScreen(width <= 480);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <Container fluid className="about-section" id="about">
      <Particle />
      <Container>
        <Row style={{ justifyContent: "center", padding: isSmallScreen ? "5px" : "10px" }}>
          <Col
            md={7}
            style={{
              justifyContent: "center",
              paddingTop: isSmallScreen ? "20px" : isMobile ? "25px" : "30px",
              paddingBottom: isSmallScreen ? "30px" : isMobile ? "40px" : "50px",
            }}
          >
            <h1 style={{ 
              fontSize: isSmallScreen ? "clamp(1.8rem, 8vw, 2.2rem)" : isMobile ? "clamp(2rem, 6vw, 2.4rem)" : "2.1em", 
              paddingBottom: isSmallScreen ? "15px" : isMobile ? "18px" : "20px",
              lineHeight: "1.2",
              marginBottom: isSmallScreen ? "10px" : isMobile ? "15px" : "20px"
            }}>
              Know Who <strong className="purple">I'M</strong>
            </h1>
            <Aboutcard />
          </Col>
          <Col
            md={5}
            style={{ 
              paddingTop: isSmallScreen ? "40px" : isMobile ? "80px" : "120px", 
              paddingBottom: isSmallScreen ? "30px" : isMobile ? "40px" : "50px" 
            }}
            className="about-img"
          >
            <img src={laptopImg} alt="about" className="img-fluid" />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default About;
